import { render, staticRenderFns } from "./Rw5FilesList.vue?vue&type=template&id=332639fa&scoped=true"
import script from "./Rw5FilesList.vue?vue&type=script&lang=js"
export * from "./Rw5FilesList.vue?vue&type=script&lang=js"
import style0 from "./Rw5FilesList.vue?vue&type=style&index=0&id=332639fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332639fa",
  null
  
)

export default component.exports